import setFeature from './set-feature.action';

export default setFeature;
